const workerPointList = () => import('@/views/main/workerPoint/list/List.vue')
export default {
  path: '/main/workerPoint/list',
  name: 'workerPointList',
  component: workerPointList,
  children: []
}
